export default __webpack_public_path__ + "87c5e32231a5aef4d0c610e0bff1e8f0.svg";